import React from "react";
import { useNavigate } from "react-router-dom";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { VimplayData } from "../../../../lib/data/vimplay.data";
import Footer from "../../../../containers/Footer";
import BackIcon from "../../../../assets/svg/BackIcon";

const Vimplay = () => {
  const navigate = useNavigate();

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="slots-sectionPage MobileGamesSection vimplay-games">
          <div className="d-flex justify-content-between align-items-center HeadingSection mt-3 mb-3">
            <h2 className="sectionTitle border-0">Vimplay</h2>
            <a className="back-link" href="/">
              Back <BackIcon />
            </a>
          </div>

          <ul className="games-listing">
            {Object.values(VimplayData).map((game) => {
              return (
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(game.redirectUrl);
                    }}
                  >
                    <img src={game.imgUrl} alt={game.alt} />
                    {/* <h3 className="name mt-3">{game?.name}</h3> */}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Vimplay;
